export default __webpack_public_path__ + "static/media/RotatoryTiller.25bccc77.jpg";